var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen-btn-con",on:{"click":_vm.handleChange}},[_c('Tooltip',{attrs:{"content":_vm.value ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('Icon',{attrs:{"type":_vm.value ? 'arrow-shrink' : 'arrow-expand',"size":23}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b1ba02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main-components/fullscreen.vue
// module id = null
// module chunks = 